<div class="input-container search-input-container">
    <input type="text" class="search-input" [placeholder]="placeholder | trans" [formControl]="searchControl">
    <mat-icon svgIcon="search" *ngIf="!hideIcon"></mat-icon>
</div>
